import { styled } from "@mui/material/styles"

export const StyledIframe = styled("iframe")({
  width: "100%",
  position: "absolute",
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  height: "100%",
  borderRadius: "10px"
})

export const StyledDiv = styled("div")({
  position: "relative",
  overflow: "hidden",
  width: "100%",
  paddingTop: "56.25%",
  marginBottom: 25
})
